"use strict";

// this file is import from webpack config use es5 export and require
// do not change it
const lodash = require('lodash');

const Color = require('color'); // caption color object


function normalizeColorsObject(colors) {
  const colorsObj = {};

  if (lodash.isString(colors[0])) {
    colorsObj.foreground = colors[0] ? Color(colors[0]).object() : null;
    colorsObj.background = colors[1] ? Color(colors[1]).object() : null;
  } else if (lodash.isObject(colors[0])) {
    colors.forEach(color => {
      if (color.value === '') {
        color.value = '#fff';
      }

      colorsObj[color.name] = Color(color.value).object();
    });
  }

  return colorsObj;
} // takes a { r, g, b, a } object and converts to css string


function rgbaToString({
  r,
  g,
  b,
  a
}) {
  return `rgba(${r}, ${g}, ${b}, ${a})`;
}

function colorStringToObject(color) {
  return Color(color).object();
} // return color.js class from any color format


function getColor(color) {
  return Color(color);
}

module.exports = {
  normalizeColorsObject,
  rgbaToString,
  colorStringToObject,
  getColor
};